(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('[data-product-variant]'))return;const price=event.target.closest('.product-content').querySelector('[data-product-price]');const selected=event.target.selectedOptions[0];if(price&&selected)price.textContent=selected.dataset.price;const oldPrice=event.target.closest('.product-content').querySelector('.price-line s');if(oldPrice)oldPrice.hidden=true;});

  } catch(e) { console.error(e); }
})();
})();
